import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Form, Input } from 'antd';
import { useSelector } from 'react-redux';
import { openMessage } from '../../../redux/actions';
import regex, { NOTIFIES } from '../../../constants/system.keys';

const layout = {
  labelCol: { span: 6 },
  wrapperCol: { span: 16 },
};

const AddWhitelistIPComponent = ({ namespace, onAdd, onDone }) => {
  const formRef = useRef();
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const { addWhiteListDevice } = useSelector((state) => state);
  const [addDataReturn, setAddDataReturn] = useState();
  const [requestId, setRequestId] = useState();
  const addressRef = useRef(null);

  useEffect(() => {
    if (addWhiteListDevice && addWhiteListDevice.requestId === requestId) {
      setAddDataReturn(addWhiteListDevice);
    }
  }, [addWhiteListDevice, requestId]);

  useEffect(() => {
    if (addDataReturn) {
      const { result, data, message } = addDataReturn;
      if (result === -3) {
        form.setFields([
          {
            name: 'address',
            errors: [message],
          },
        ]);
      }
      if (result === 1) {
        openMessage(NOTIFIES.SUCCESS, message);
        onDone(data);
      }
    }
  }, [addDataReturn, form, onDone]);

  useEffect(() => {
    form.resetFields();
    forceUpdate({});
  }, [form]);
  useEffect(() => {
    if (namespace) {
      form.setFieldsValue({
        namespace: namespace,
      });
    }
  }, [form, namespace]);

  useEffect(() => {
    if (addressRef.current) {
      setTimeout(() => { addressRef.current.input.focus() }, 1)
    }
  }, [addressRef]);

  const onFinish = (values) => {
    let current = new Date().getTime();
    setRequestId(current);
    return onAdd(current, { ...values });
  };

  const onChange = e => {
    const val =
      e.target.value &&
      e.target.value.split("-") &&
      e.target.value.split("-").join("");
    const finalVal = val.match(/.{1,2}/g) && val.match(/.{1,2}/g).join("-");
    form.setFieldsValue({
      address: finalVal,
    })
  };

  return (
    <div className="add-whitelist-ip-component">
      <Form form={form} {...layout} onFinish={onFinish} name="form_in_modal">
        <Form.Item
          name="address"
          label={t('MAC Address')}
          rules={[
            {
              required: true,
              message: t('Please input the address!'),
            },
            {
              pattern: regex.isNameMAC,
              message: t('Please enter up to 200 characters including letters and numbers!'),
            },
            {
              max: 200,
              message: t('Please input up to 200 characters!'),
            },
          ]}
        >
          <Input ref={addressRef} onChange={onChange} placeholder={t('MAC Address')} />
        </Form.Item>
        <Form.Item
          name="namespace"
          label={t('Namespace')}
          rules={[
            {
              required: true,
              message: t('Please input the namespace!'),
            },
            {
              pattern: regex.isurl,
              message: t('Please input the namespace!'),
            },
            {
              max: 80,
              message: t('Please input up to 80 characters!'),
            },
          ]}
        >
          <Input disabled placeholder={t('Namespace')} />
        </Form.Item>
        <div className="create-btn">
          <Form.Item shouldUpdate={true}>
            <Button type="primary" htmlType="submit">
              {t('Create')}
            </Button>
          </Form.Item>
        </div>
      </Form>
    </div>
  );
};

export default AddWhitelistIPComponent;
